import React from "react";
import { motion } from "framer-motion";

const AyurvedicApproach = ({
  leftHeading,
  leftItems,
  rightHeading,
  rightDescription,
  rightItems,
}) => {

const containerVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -50,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const fadeRight = {
  hidden: {
    opacity: 0,
    x: 50,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const listItemVariant = {
  hidden: {
    opacity: 0,
    y: 15,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
    },
  },
};

  return (
    <motion.section
      className="ayurvedic-approach-section container"
      variants={containerVariant}
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.15,
      }}
    >

      {/* LEFT BOX */}

      <motion.div
        className="ayurvedic-approach-left"
        variants={fadeLeft}
      >

        <motion.h3
          className="card-heading"
          variants={fadeUp}
        >
          {leftHeading}
        </motion.h3>

        <motion.ul
          className="ayurvedic-approach-list"
          variants={containerVariant}
        >

          {leftItems.map((item, index) => (
            <motion.li
              key={index}
              className="section-text"
              variants={listItemVariant}
            >
              <strong>{item.title}</strong> {item.text}
            </motion.li>
          ))}

        </motion.ul>

      </motion.div>

      {/* RIGHT BOX */}

      <motion.div
        className="ayurvedic-approach-right"
        variants={fadeRight}
      >

        <motion.h3
          className="card-heading"
          variants={fadeUp}
        >
          {rightHeading}
        </motion.h3>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          {rightDescription}
        </motion.p>

        <motion.ul
          className="ayurvedic-approach-benefits section-text"
          variants={containerVariant}
        >

          {rightItems.map((item, index) => (
            <motion.li
              key={index}
              variants={listItemVariant}
            >
              {item}
            </motion.li>
          ))}

        </motion.ul>

      </motion.div>

    </motion.section>
  );
};

export default AyurvedicApproach;